import FJMobileImageToImageEdit from './FJMobileImageToImageEdit';
import { useSelector, useDispatch } from 'react-redux';
import { setSliceIsExpandEditAction, setSlicePromptAction } from '../../../redux/slices/FJSliceImageToImage';
import FJActionImageToImage from '../../../redux/action/FJActionImageToImage';
import useLocalStore from '../../../hooks/useLocalStore';
import { useCallback } from 'react';
import FJUtil from '../../../util/FJUtil';
import FJActionCommon from '../../../redux/action/FJActionCommon';
import { useMemo } from 'react';
import { STYLE_LIST } from '../../../config/dataConfig/FJImageToImageData';
import FJConstant from '../../../constants/FJConstant';

const FJMobileImageToImageEditContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const prompt = useSelector(state => state.imageToImage.prompt);
    const uploadImageInfo = useSelector(state => state.imageToImage.uploadImageInfo);
    const generateQuantity = useSelector(state => state.imageToImage.generateQuantity);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const isExpandEdit = useSelector(state => state.imageToImage.isExpandEdit);
    const selectedStyle = useSelector(state => state.imageToImage.selectedStyle);

    const isPro = useMemo(() => {
        const category = STYLE_LIST.find(ca => ca.list.find(item => item.value === selectedStyle));
        const styleInfo = category ? category.list.find(item => item.value === selectedStyle) : {};
        return styleInfo.isPro;
    }, [selectedStyle]);
    const isExpensive = useMemo(() => {
        const category = STYLE_LIST.find(ca => ca.list.find(item => item.value === selectedStyle));
        const styleInfo = category ? category.list.find(item => item.value === selectedStyle) : {};
        return styleInfo.isExpensive;
    }, [selectedStyle]);

    const changePrompt = value => {
        dispatch(setSlicePromptAction(value));
    };
    const uploadImg = file => {
        dispatch(FJActionImageToImage.uploadImageAction(file));
    };
    const _onGenerate = useCallback(() => {
        if (FJUtil.isGeneratingStatus(taskStatus)) return;
        dispatch(FJActionImageToImage.generateAction());
        dispatch(FJActionCommon.setHeaderTabIndexAction(FJConstant.CREATIONS));
    }, [dispatch, taskStatus]);

    const _onExpandEdit = () => {
        dispatch(setSliceIsExpandEditAction(!isExpandEdit));
    };

    return (
        <FJMobileImageToImageEdit
            prompt={prompt}
            uploadImageInfo={uploadImageInfo}
            changePrompt={changePrompt}
            uploadImg={uploadImg}
            generateQuantity={generateQuantity}
            onGenerate={_onGenerate}
            taskStatus={taskStatus}
            freeNumCreation={freeNumCreation}
            creditNumber={creditNumber}
            isProjectLoading={isProjectLoading}
            isExpandEdit={isExpandEdit}
            onExpandEdit={_onExpandEdit}
            isPro={isPro}
            isExpensive={isExpensive}
        />
    );
};
export default FJMobileImageToImageEditContainer;
